module.exports = __webpack_public_path__ + "static/img/80713397.572179f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/80713397.svg
// module id = WlHU
// module chunks = 1